import React from 'react';

import { FWorkflowStepFragment, WorkflowStepStatus } from '@dashboard/generated/wp/platform';
import { CheckCircle, Error, NotInterestedOutlined, RemoveCircle, WatchLaterOutlined } from '@mui/icons-material';

type Props = {
  step: FWorkflowStepFragment;
};
export default function TitleIcon({ step }: Props) {
  switch (step.status) {
    case WorkflowStepStatus.Disabled:
    case WorkflowStepStatus.Canceled:
      return <NotInterestedOutlined sx={{ color: 'cadet.500' }} />;
    case WorkflowStepStatus.Failed:
      return <Error sx={{ color: 'brand.red' }} />;
    case WorkflowStepStatus.Pending:
      return <RemoveCircle sx={{ color: 'cadet.500' }} />;
    case WorkflowStepStatus.Processing:
      return <WatchLaterOutlined sx={{ color: 'brand.blue' }} />;
    case WorkflowStepStatus.Succeeded:
      return <CheckCircle sx={{ color: 'brand.green' }} />;
  }
}
